import { FilePurpose } from '../../libs/interfaces/filePurpose';
import { request } from '../../utils/request';
import uploadFile from '../fileUpload/uploadFile';

const uploadCycle = (
  file_purpose: FilePurpose,
  file?: File,
  requires_image?: boolean
) =>
  uploadFile({
    file_purpose,
    file,
    requires_image,
  });

type ProfileImages = { profile_image?: number; banner_image?: number };
const uploadUserProfileImageToServer = async (
  body: ProfileImages,
  authToken: string
) =>
  request({
    method: 'POST',
    url: `/auth/upload-url`,
    formData: body,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });

type ReqBody = {
  files: Array<{
    title: keyof ProfileImages;
    file_purpose: FilePurpose;
    file?: File;
    requires_image?: boolean;
  }>;
  authToken: string;
};

export const uploadUserProfileImages = async (req: ReqBody) => {
  const fileUploadRes = await Promise.all(
    req.files.map(({ file_purpose, file, requires_image }) =>
      uploadCycle(file_purpose, file, requires_image)
    )
  );

  const uploadedImages = req.files.reduce(
    (obj, fileObj, idx) => {
      obj[fileObj.title] = fileUploadRes[idx].file_id;
      return obj;
    },
    {} as Record<keyof ProfileImages, number>
  );

  await uploadUserProfileImageToServer(
    {
      profile_image: uploadedImages.profile_image,
      banner_image: uploadedImages.banner_image,
    },
    req.authToken
  );
};
